import { Axios } from "../../axios.interceptor";

const h = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getActivity        = (params, token)       => Axios.get("/api/v1/admin/blog/activity", { params, ...h(token) });
export const getMyActivity      = (params, token)       => Axios.get("/api/v1/admin/blog/activity/me", { params, ...h(token) });
export const getResourceHistory = (type, id, token)     => Axios.get(`/api/v1/admin/blog/activity/resource/${type}/${id}`, h(token));
